import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { CreateScreeningService } from '@/app/pages/screening-brief-create/services/create-screening/create-screening.service';
import { CUSTOM_RESTRICTION_CATEGORY_ID, CUSTOM_RESTRICTION_EXAMPLES } from '../../screening-brief.constants';

/**
 * The shared "Content no-go list" — every red flag the brief has collected, plus the block for
 * writing your own. Rendered below the category browser and always visible, so the list the user
 * is building never scrolls out of sight.
 */
@Component({
  selector: 'sbs-screening-nogo-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './screening-nogo-list.html',
})
export class ScreeningNogoList {

  readonly createScreeningService = inject(CreateScreeningService);

  readonly examples = CUSTOM_RESTRICTION_EXAMPLES;

  /** The in-progress custom rule. */
  readonly draft = signal<string>('');

  readonly count = computed(() => this.createScreeningService.restrictions().length);

  readonly countLabel = computed(() => {
    const total = this.count();
    return `${total} ${total === 1 ? 'rule' : 'rules'}`;
  });

  setDraft(value: string): void {
    this.draft.set(value);
  }

  /** Commits the typed rule. Bound to both the Add button and the Enter key. */
  addDraft(): void {
    const text = this.draft().trim();
    if (!text) {
      return;
    }
    this.createScreeningService.addRestriction(
      CUSTOM_RESTRICTION_CATEGORY_ID,
      CUSTOM_RESTRICTION_CATEGORY_ID,
      text,
      true,
    );
    this.draft.set('');
  }

  addExample(example: string): void {
    this.createScreeningService.addRestriction(
      CUSTOM_RESTRICTION_CATEGORY_ID,
      CUSTOM_RESTRICTION_CATEGORY_ID,
      example,
      true,
    );
  }

  remove(id: string): void {
    this.createScreeningService.removeRestriction(id);
  }
}
